import React from 'react';
import LeftSideBar from './LeftSideBar'
import { useCurrentProject } from 'hooks/projects/useCurrentProject';
import { useCurrentUserWithInitials } from 'hooks/users/useCurrentUserWithInitials';
import {useProject} from 'hooks/projects/queries';

const QualLeftSideBar = (props) => {
  const { user } = useCurrentUserWithInitials();
  const {projectId} = useCurrentProject()
  const { data: project, isLoading: projectLoading } = useProject(projectId);

  return (
    <div style={{height:"100%"}}>
      <LeftSideBar  transcriptID={props.transcriptID}
                    projectID={projectId || props.projectID}
                    hasEditPermission={props.hasEditPermission}
                    user={user}
                    project={project}
                    />
    </div>
  );
}

export default QualLeftSideBar;